// Multi-tenancy scoping helper (2026-08-05 leak fix).
//
// Returns the currently authenticated user's uid, or null if auth hasn't
// loaded / no one is signed in. Used by uploadPersistence and
// crossTabUploadSync to stamp records/messages with an owner and to filter
// reads/receives against the current user.
//
// The firebase/auth import is deferred to first-call rather than the module's
// top level. Loading it at the top forces Jest to pull the full firebase SDK
// bundle (which drags in undici, which needs a TextEncoder polyfill that this
// project's CRA setup doesn't ship) into any test file that transitively
// imports this module — even tests that never actually call the function.
// Deferring keeps this module cheap to import.
let cachedGetAuth = null;

export const getCurrentOwnerUid = () => {
  try {
    if (!cachedGetAuth) {
      // eslint-disable-next-line global-require
      cachedGetAuth = require("firebase/auth").getAuth;
    }
    return cachedGetAuth()?.currentUser?.uid || null;
  } catch {
    return null;
  }
};
